<template>
  <div class="tooltip">
    <span>{{ label }}</span>
    <el-tooltip placement="top">
      <template v-slot:content>
        <slot name="content"></slot>
      </template>
      <i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
    </el-tooltip>
    <div :class="`bg i-home-commission-${className}`"></div>
  </div>
</template>

<script>
export default {
  name: 'tooltip',
  props: {
    label: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.tooltip {
  background-color: #E9F1FF;
  border-bottom: 1px solid #EEEEEE;
  font-size: 14px;
  font-weight: bold;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  color: #333;
  position: relative;
  .bg {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .icon-a-help-circle-obangzhu-xian {
    font-size: 14px;
    color: #999;
    margin-left: 4px;
    font-weight: 400;
  }
}
</style>
